<mat-select
  data-test-id="mat-select"
  class="select"
  [(value)]="selectedItem"
  (selectionChange)="onSelectChange($event)"
>
  <mat-option
    *ngFor="let item of options"
    [value]="item"
    [attr.data-test-id]="item.id"
  >
    {{ item.name }}
  </mat-option>
</mat-select>

<!-- <mat-form-field appearance="outline" class="select-container">
  <mat-select
    data-test-id="mat-select"
    class="select"
    [(value)]="selectedItem"
    (selectionChange)="onSelectChange($event)"
  >
    <mat-option
      *ngFor="let item of options"
      [value]="item"
      [attr.data-test-id]="item.id"
    >
      {{ item.name }}
    </mat-option>
  </mat-select>
</mat-form-field> -->
